export default "__VITE_ASSET__c412748b__"